import { useEffect } from "react";
import {
  decodeQueryParams,
  decodeQueryParamsToObject,
} from "../../../../utils/EncodeDecodeQueryParams";

const useEditorInitialLoad = ({
  id,
  location,
  currentUrl,
  headerData,
  setHeaderData,
  setListProblemData,
  setPengecekanSaved,
  fetchHeader,
  fetchVerifSetting,
}) => {
  // first time initializations
  useEffect(() => {
    setListProblemData([]);
    const isNew = currentUrl.includes("new");
    if (isNew) {
      // load default header from url query "key"
      const urlParams = new URLSearchParams(location.search);
      const key = urlParams.get("key");
      if (key) {
        decodeQueryParams(key).then((decodedKey) => {
          const urlParams = new URLSearchParams(decodedKey);
          const filterNew = urlParams.get("filter");
          if (filterNew) {
            const { filterText, filterObject } = decodeQueryParamsToObject({
              filterText: filterNew,
              configFilters: [
                {
                  field: "kendaraan_id",
                  alias: "kendaraan",
                  type: "object",
                },
              ],
            });
            if (filterObject.kendaraan) {
              setHeaderData({
                ...headerData,
                data_kendaraan: filterObject.kendaraan,
                kendaraan_id: filterObject.kendaraan.id,
              });
            }
          }
        });
      }
      setPengecekanSaved({
        bagian_depan: false,
        bagian_samping: false,
        bagian_belakang: false,
        bagian_dalam: false,
      });
    } else {
      fetchHeader(id);
    }

    // load verif setting (pengecekan + pemakaian, one request)
    fetchVerifSetting();
  }, []);
};

export default useEditorInitialLoad;
